import { render, staticRenderFns } from "./Registrant.vue?vue&type=template&id=2fa30693"
import script from "./Registrant.vue?vue&type=script&lang=js"
export * from "./Registrant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports